export enum LatestAccomplishmentType {
  Achievement = 'achievement',
  Activity = 'activity',
  Badge = 'badge',
  None = 'none',
}
